import { render, staticRenderFns } from "./PlayerActivities.vue?vue&type=template&id=72388c42&scoped=true&"
import script from "./PlayerActivities.vue?vue&type=script&lang=js&"
export * from "./PlayerActivities.vue?vue&type=script&lang=js&"
import style0 from "./PlayerActivities.vue?vue&type=style&index=0&id=72388c42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72388c42",
  null
  
)

export default component.exports